import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ICampaignAdsState } from '../../interfaces/state.interfaces';
import { ICampaignAds } from '../../interfaces/campaign-ads.interface';

const initialState: ICampaignAdsState = {
    ads: [],
    sessionKey: null,
};

const campaignAdsSlice = createSlice({
    name: 'campaignAds',
    initialState,
    reducers: {
        SetCampaignAds(
            state,
            action: PayloadAction<{
                ads: ICampaignAds[];
                sessionKey: string | null;
            }>,
        ) {
            state.ads = action.payload.ads;
            state.sessionKey = action.payload.sessionKey;
        },
        SetCampaignAdsInitialState(state) {
            state.ads = [];
            state.sessionKey = null;
        },
    },
});

export const { SetCampaignAds, SetCampaignAdsInitialState } = campaignAdsSlice.actions;

export const campaignAdsReducer = campaignAdsSlice.reducer;
